import React, { useContext, useEffect } from 'react';
import { Navigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import { AuthContext } from './AuthContext';

function RequireRole({ roles, anyRoles, children }) {
  const { hasAnyRole } = useContext(AuthContext);

  let authorized = false;
  if (Array.isArray(roles)) {
    authorized = hasAnyRole(roles);
  } else if (Array.isArray(anyRoles)) {
    authorized = hasAnyRole(anyRoles);
  }

  useEffect(() => {
    if (!authorized) {
      toast.error('You are not authorized to view this page');
    }
  }, [authorized]);

  if (!authorized) {
    return <Navigate to="/unauthorized" replace />;
  }

  return <>{children}</>;
}

export default RequireRole;
